import { InputTypes, InputCommonProperty } from '../enums';

const InputCommonProps = {
  props: {
    [InputCommonProperty.Id]: {
      default: '',
      type: String,
    },
    [InputCommonProperty.Name]: {
      default: '',
      type: String,
    },
    [InputCommonProperty.Autocomplete]: {
      default: 'off',
      type: String,
    },
    [InputCommonProperty.Value]: {
      default: '',
      type: [String, Object, Number],
    },
    [InputCommonProperty.Label]: {
      default: '',
      type: String,
    },
    [InputCommonProperty.Type]: {
      default: InputTypes.Text,
      type: String,
    },
    [InputCommonProperty.Disabled]: {
      default: false,
      type: Boolean,
    },
    [InputCommonProperty.IsReadonly]: {
      default: false,
      type: Boolean,
    },
    [InputCommonProperty.Placeholder]: {
      default: '',
      type: String,
    },
  },
};

export default InputCommonProps;
